import type {SettlementPaymentMethod} from '@afriex/core/domain/types';

import type {
  SettlementPaymentMethodListParams,
  SettlementPaymentMethodPayload,
} from '@/types';

export type SettlementAccountListProps = {
  error: unknown;
  isLoading: boolean;
  list: SettlementPaymentMethod[];
  pageInfo: {total: number; page: number};
  fetchList: (params: SettlementPaymentMethodListParams) => void;
  refetchCurrentPage: () => Promise<void>;
  displayPage: number;
  isPageReset: boolean;
  filterCount: number;
  filtersToApply: SettlementPaymentMethodListParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | boolean | undefined,
  ) => void;
  handleApplyFilters: () => void;
};

/**
 * A rejection the validator attributed to one control: `field` is an `info`
 * key, or `currencyCode` / `countryCode` / `channel` for the top-level ones.
 */
export type SettlementAccountFieldError = {field?: string; message: string};

export enum SettlementAccountActionType {
  UPDATE_SETTLEMENT_ACCOUNT = 'UPDATE_SETTLEMENT_ACCOUNT',
  RESET_SETTLEMENT_ACCOUNT = 'RESET_SETTLEMENT_ACCOUNT',
}

interface UpdateSettlementAccountAction {
  type: SettlementAccountActionType.UPDATE_SETTLEMENT_ACCOUNT;
  payload: Partial<SettlementPaymentMethodPayload>;
}

interface ResetSettlementAccountAction {
  type: SettlementAccountActionType.RESET_SETTLEMENT_ACCOUNT;
  payload: Partial<SettlementPaymentMethodPayload>;
}

export type SettlementAccountAction =
  UpdateSettlementAccountAction | ResetSettlementAccountAction;
